import { render, staticRenderFns } from "./HelptableFormHeader.vue?vue&type=template&id=57708838"
import script from "./HelptableFormHeader.vue?vue&type=script&lang=js"
export * from "./HelptableFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports